exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.message {\n    color: silver;\n    font-style: oblique;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/project-db-records/project-db-records.component.css
// module id = ../../../../../src/app/project-db-records/project-db-records.component.css
// module chunks = main